/**
 * Datos de contacto de Biosany, en un solo lugar reutilizable (secciones de
 * contacto, footer, CTAs). Los enlaces `tel:` / `wa.me` se derivan del número
 * quitando espacios y símbolos.
 */

export const CONTACT = {
	email: "contacto@biosany.com",
	/** Teléfono fijo/celular en formato legible. */
	phone: "55 6536 7198",
	/** WhatsApp en formato legible. */
	whatsapp: "777 4118763",
	/** Horario de atención. */
	hours: "24/7"
} as const

/** Solo dígitos, para enlaces `tel:` y `wa.me` (sin espacios ni símbolos). */
const digits = (value: string): string => value.replace(/[^\d]/g, "")

/** `tel:` listo para usar en un enlace. */
export const telHref = `tel:${digits(CONTACT.phone)}`

/**
 * Enlace de WhatsApp (`wa.me`). Admite un mensaje opcional que se codifica en la
 * URL para prellenar el chat.
 */
export const whatsappHref = (message?: string): string => {
	const base = `https://wa.me/+52${digits(CONTACT.whatsapp)}`
	return message ? `${base}?text=${encodeURIComponent(message)}` : base
}

/** `mailto:` con asunto y cuerpo opcionales prellenados. */
export const mailtoHref = (subject?: string, body?: string): string => {
	const params = new URLSearchParams()
	if (subject) params.set("subject", subject)
	if (body) params.set("body", body)
	const query = params.toString()
	return query ? `mailto:${CONTACT.email}?${query}` : `mailto:${CONTACT.email}`
}
